import React from "react";
import { Helmet } from "react-helmet-async";
import CpntHeaderFO from "../CpntHeaderFO";
import CpntFooterFO from "../CpntFooterFO";
import { Outlet, useLocation } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import useGoogleAnalytics from "../hooks/analytics_hook";


interface IProps {
  title?: React.ReactNode;
}

const FoLayoutConnecte: React.FC<IProps> = ({title}) => {

  const contenuAEditer = null;
  const location = useLocation();
  
  useGoogleAnalytics();
  
  return (
    <div >
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title ? title : process.env.REACT_APP_WEBSITE_TITLE}</title>
        {location && (
          <link
            rel="canonical"
            href={window.location.pathname + location.pathname}
          />
        )}
        <meta
          name="description"
          content="Services aux éditeurs"
        />
      </Helmet>
      <CpntHeaderFO />
        <div className="App-body-FO-Connecte">
          <Container >
            <Row>
              {/* <Col>&nbsp;</Col> */}
              <Col xs={12}>    
                <div
                id={`${contenuAEditer ? "edit-layout-mode" : ""}`}
                className={"container"}
              >
                <div className="row">
                  {contenuAEditer && ( 
                    //contenuAEditer?.Id 
                    <div className="col-4 card edit-layout-control sticky-top margin-top-sticky ">
                      {/* <EditLayout /> */}
                    </div>
                  )}
                  <div
                    className={`col App-content-wrapper product-page ${
                      contenuAEditer ? "edit-layout-contenu" : ""
                    }`}
                  >
                    <Outlet />
                  </div>
                </div>
              </div>
              </Col>
            </Row>
          </Container>
        </div>
      <CpntFooterFO />
      </div>
  );
};

export default FoLayoutConnecte;
